"use client"

import type { TrackEventProperties } from "@/modules/tracking/types"
import type { FunctionComponent, PropsWithChildren } from "react"

import { useEffect, useRef, useState } from "react"

import { useTracking } from "@/modules/tracking/useTracking"
import { useIntersectionObserver } from "@/modules/window/hooks/useIntersectionObserver"

type TrackObserverProps = {
  eventName: string
  eventProperties: TrackEventProperties
  observerOptions?: IntersectionObserverInit
} & PropsWithChildren

export const TrackObserver: FunctionComponent<TrackObserverProps> = ({
  eventName,
  eventProperties,
  observerOptions,
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const tracking = useTracking()
  const [refIsLoaded, setRefIsLoaded] = useState(false)
  const [isAlreadyTracked, setIsAlreadyTracked] = useState(false)

  const [isObserved] = useIntersectionObserver(ref.current, observerOptions)

  useEffect(() => {
    setRefIsLoaded(ref.current !== null)

    if (refIsLoaded && isObserved && !isAlreadyTracked) {
      tracking?.track(eventName, eventProperties)
      setIsAlreadyTracked(true)
    }
  }, [
    isAlreadyTracked,
    setIsAlreadyTracked,
    isObserved,
    tracking,
    eventName,
    eventProperties,
    ref,
    refIsLoaded,
    setRefIsLoaded,
  ])

  return <div ref={ref}>{children}</div>
}
